var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisionaiNav1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_106156",
    "data-name": "Path 106156",
    d: "M28,10a1.143,1.143,0,0,0,0,2.286h4.1l-9.478,9.478a1.143,1.143,0,1,0,1.616,1.616L33.714,13.9V18A1.143,1.143,0,0,0,36,18V11.143A1.143,1.143,0,0,0,34.857,10ZM15.429,11.143A3.432,3.432,0,0,0,12,14.571v16A3.432,3.432,0,0,0,15.429,34h16a3.432,3.432,0,0,0,3.429-3.429V23.714a1.143,1.143,0,0,0-2.286,0v6.857a1.144,1.144,0,0,1-1.143,1.143h-16a1.144,1.144,0,0,1-1.143-1.143v-16a1.144,1.144,0,0,1,1.143-1.143h6.857a1.143,1.143,0,0,0,0-2.286Z",
    transform: "translate(-12 -10)",
    fill: "#080e15"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisionaiNav1);
export default __webpack_public_path__ + "static/media/visionai_nav1.5d2ce44377f607b6fab3a9c4633497c0.svg";
export { ForwardRef as ReactComponent };